module.exports = __webpack_public_path__ + "static/media/about.f599be69.png";